import { Route, Switch } from 'react-router';
import cn from 'classnames';

import LINK from 'constants/link.const';
import { useTheme } from 'providers/Theme.provider';

import { FormBuilderPage } from './builder/FormBuilderPage.component';
import { FormsListPage } from './list/FormsListPage.component';

import CN from './ConsultationFormsLayout.module.scss';

export const ConsultationFormsLayout = () => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="ConsultationFormsLayout"
      className={cn({
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <Switch>
        <Route path={LINK.settingsFormBuilder} component={FormBuilderPage} />
        <Route path={LINK.settingsForms} component={FormsListPage} />
      </Switch>
    </div>
  );
};
